import { FlightsShoppingPwaFlightInformationResultsLoading } from '__generated__/api';
import {
  ClientMetadataStore,
  ErrorStore,
  FlightsSelectedJourneyReviewStore,
  FreeCancellationStore,
  GaiaIdStore,
  JourneyStartEndDatesStore,
  PageTitleStore,
  PriceSummaryStore,
  StepIndicatorStore,
  FlightsSupportedAncillariesStore
} from 'stores';
import { AdditionalShoppingStore } from 'stores/additional-shopping-store';

const hydrateDetailsStores = (
  response: FlightsShoppingPwaFlightInformationResultsLoading.FlightsDetail,
  freeCancellationStore: FreeCancellationStore,
  flightsSelectedJourneyReviewStore: FlightsSelectedJourneyReviewStore,
  priceSummaryStore: PriceSummaryStore,
  errorStore: ErrorStore,
  clientMetadataStore: ClientMetadataStore,
  pageTitleStore: PageTitleStore,
  stepIndicatorStore: StepIndicatorStore,
  gaiaIdStore: GaiaIdStore,
  journeyStartEndDatesStore: JourneyStartEndDatesStore,
  flightsSupportedAncillariesStore: FlightsSupportedAncillariesStore,
  additionalShoppingStore: AdditionalShoppingStore
) => {
  const {
    freeCancellation,
    priceSummary,
    serverErrorMessaging,
    clientMetadata,
    pageTitle,
    stepIndicator,
    flightsSelectedJourneyReview,
    gaiaIds,
    journeyStartEndDates,
    flightsSupportedAncillaries,
    additionalShopping
  } = response;

  freeCancellationStore.hydrate({ freeCancellation });
  // TODO: Add support for roundtrip & multidest
  priceSummaryStore.hydrate({ priceSummary });
  errorStore.hydrate({ failedRequestMessaging: serverErrorMessaging });
  flightsSelectedJourneyReviewStore.hydrate({ flightsSelectedJourneyReview });
  clientMetadataStore.hydrate({ clientMetadata });
  pageTitleStore.hydrate({ pageTitle });
  stepIndicatorStore.hydrate({ stepIndicator });
  gaiaIdStore.hydrate({ gaiaIds });
  journeyStartEndDatesStore.hydrate({ journeyStartEndDates });
  flightsSupportedAncillariesStore.hydrate({ flightsSupportedAncillaries });
  additionalShoppingStore.hydrate({ additionalShopping });
};
export const DetailsController = {
  hydrateDetailsStores
};
